import { NgModule } from '@angular/core';
import { OpportunityAttachmentsCardComponent } from './opportunity-attachments.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyUploaderModule } from '@vendasta/galaxy/uploader';

@NgModule({
  imports: [CommonModule, TranslateModule, GalaxyUploaderModule],
  declarations: [OpportunityAttachmentsCardComponent],
  exports: [OpportunityAttachmentsCardComponent],
  providers: [],
})
export class OpportunityAttachmentsModule {}
